import React, { useState, useEffect } from 'react';

import { BedCard } from '../../components/BedCard/BedCard';
import { Header } from "../../components/Header/Header";
import SideBar from "../../components/SideBar/Sidebar";
import ToggleSwitch from '../../components/ToggleSwitch/ToggleSwitchNew';

import {
    bedDetailAction,
    bedIdAction,
    patientDataAction,
    deviceVitalDataAction,
    alarmDataAction,
    notificationDataAction,
    filterAction,
    viewTypeAction,
    wardDetailsAction,
    addColumnBedListAction,
    removeColumnBedListAction,
    hospitalDataAction,
    clearAlarms,
    bedDataAction,
    selectedWardAction,
} from '../../modules/actions/action';
import {
    openSocketConnection,
    closeSocketConnection,
    setBedDetailsAction,
    setBedIdAction,
    setPatientDataAction,
    setDeviceVitalDataAction,
    setAlarmDataAction,
    setNotificationDataAction,
    setWardDetailAction
} from '../../socket/socket';

import filterSvg from "../../common/icons/svg/filter.svg";
import "./Homepage.scss";
import { connect } from 'react-redux';
import { SORT_TYPES, VIEW_TYPES } from '../../common/constant/common-constants';
import SubHeader from '../../components/SubHeader/SubHeader';
import BedContainer from '../../container/BedContainer/BedContainer';
import PatientModal from '../../container/PatientModal/PatientModal';
import { test } from '../../adapter/cms-adapter';
import { getHospitalDetails } from '../../helper/home-page-helper';
import { HOME_PAGE, PAGE_CONST } from '../../common/constant/page-constants';
import { IoBalance } from '../../components/Table/IoBalance/IoBalance';
import { useNavigate } from 'react-router-dom';
import { redirect } from '../../common/utils/RedirectionUtils';


function HomePage(props) {

    const [toggle, setToggle] = useState(props.config.viewType === VIEW_TYPES.GRID_VIEW ? false : true);
    const [sortType, setSortType] = useState(SORT_TYPES.FAVORITE);
    const [viewType, setViewType] = useState(props.config.viewType);
    const [showAddColumnOption, setShowAddColumnOption] = useState(false);
    const [modalConfig, setModalConfig] = useState(null);
    const [selectedWard, setSelectedWard] = useState(null);
    const [wardOption, setWardOption] = useState();
    const [hospitalName, setHospitalName] = useState("");

    const navigate = useNavigate();

    /**
         * 
         * Need to set all actions for data processing before opening the socket connection
         */
    useEffect(() => {
        setSelectedWard(props.selectedWard);
        setActionForSocket();
        openSocketConnection();
        return () => {
            closeSocketConnection();
        }

    }, []);

    useEffect(() => {
        let wardOption = [];
        let selectedWard = {};
        let bedIdArray = [];
        let tempWard = null;

        // console.log(" use effect called !!");
        getHospitalDetails().then((res) => {

            if (!res || !res.data && !res.data.wards) return;
            setHospitalName(res.data.hospitalName);
            props.hospitalDataAction(res.data);

            /**
             * 
             * create bed card, add patient Data, 
             * 
             * create entry in ward
             *      - create ward
             *      - set ward to bed mapping
             * create patient details
             *  - create bed- patient mapping
             */
            let beds = res.data.wards.map((ward) => {
                // return [...ward.beds];
                // console.log("res in ward data", ward);
                /** patient Details */

                let bedIdList = ward.beds.map((bed) => {
                    let data = {
                        bedId: bed.id,
                        data: bed.patientDetails
                    }

                    let bedData = {
                        bedId: bed.id,
                        bedName: bed.name
                    }
                    props.bedDetailAction(bedData);
                    props.bedIdAction({ bedId: bed.id });
                    props.patientDataAction(data);
                    return bed.id;
                })

                /** Ward Details */
                let wardData = {
                    id: ward.id,
                    data: {
                        id: ward.id,
                        wardName: ward.name,
                        bedList: bedIdList
                    }
                }
                props.wardDetailsAction(wardData);

                /** for dropdown */
                let wardObj = {
                    id: ward.id,
                    name: ward.id,
                    label: ward.name
                };

                if (!tempWard && !(props && props.selectedWard && props.selectedWard.id)) {
                    tempWard = wardObj;
                    handleWardChange(wardObj);
                    // if (!selectedWard.id) setSelectedWard(tempWard)
                }

                wardOption.push(wardObj);
            });
            setWardOption(wardOption);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    const setActionForSocket = () => {
        setBedDetailsAction(props.bedDetailAction);
        setBedIdAction(props.bedIdAction);
        setPatientDataAction(props.patientDataAction);
        setDeviceVitalDataAction(props.deviceVitalDataAction);
        setAlarmDataAction(props.alarmDataAction);
        setNotificationDataAction(props.notificationDataAction);
        setWardDetailAction(props.wardDetailAction);
    }

    useEffect(() => {

        let mConfig = props.config.modalConfig;
        setModalConfig(mConfig);
        props.wardDetailsAction({ selectedWard: selectedWard })

        // test();
    }, [props.config, selectedWard])

    const onToggleChange = (checked) => {

        let viewType;
        setToggle(checked);
        if (checked) viewType = VIEW_TYPES.LIST_VIEW;
        else viewType = VIEW_TYPES.GRID_VIEW;

        props.viewTypeAction({ viewType: viewType });
        setViewType(viewType);
    }

    const toggleAddColumn = (toggle) => {
        console.log(toggle);
        setShowAddColumnOption(toggle);
    }
    const handleAddColumnButtonClick = () => {

        let sac = showAddColumnOption;

        /* verify and check */
        // if (!sac) {
        //     document.getElementById("add-columnn-container").addEventListener('click', function (event) {
        //         event.stopPropagation();
        //         // toggleAddColumn(true);
        //         console.log("inside click !!");
        //     });

        //     document.addEventListener('click', function () {
        //         console.log("outside click !!");
        //         toggleAddColumn(false);
        //     });
        // } else {
        //     // document.removeEventListener('click', null)
        //     // document.getElementById("add-columnn-container").removeEventListener('click', null);
        // }
        setShowAddColumnOption(!sac);
    }

    const handleAddColumnItemClick = (event, paramObj) => {

        let value = event && event.target && event.target.checked;

        if (value) {
            props.addColumnBedListAction(paramObj);
        } else {
            props.removeColumnBedListAction(paramObj);
        }
    }

    const ifAddColumnOptionChecked = (paramObj) => {
        let listViewParameters = (props.config && props.config.listViewParameters) || [];

        let index = listViewParameters.findIndex((param) => param.name === paramObj.name);

        if (index && index > -1) return true;

        return false;
    }

    const handleWardChange = (item) => {
        setSelectedWard(item);
        props.selectedWardAction(item)
    }

    return (
        <>
            <div className={modalConfig && modalConfig.isOpen ? 'home-page blur' : 'home-page'}>
                {/* {console.log("rerendering HomePage!!!!")} */}
                <Header
                    handleWardChange={(item) => handleWardChange(item)}
                    wardOption={wardOption}
                    selectedWard={selectedWard}
                    hospitalName={hospitalName} />
                <SideBar />
                <div className='home-page-body-container'>
                    {/* <SubHeader data={props.wardDetails} /> */}
                    {/* <div className='toggle-filter-container'>
                        <div className='toggle-switch-container'>
                            <span className='grid-view-text'>Grid View</span>
                            <ToggleSwitch id="newsletter" checked={toggle} optionLabels={["", ""]} small={true} onChange={onToggleChange} />
                            <span className='list-view-text'>List View</span>
                        </div>
                        <div className='filter-container'>
                            <img src={filterSvg} alt="filter svg" onClick={() => console.log("filter clicked !!")} />
                        </div>
                        {toggle && <div className='add-column-container' id='add-columnn-container'>
                            <div className='add-column-button' onClick={(event) => handleAddColumnButtonClick(event)}>
                                +&ensp;Add Column
                            </div>
                            {showAddColumnOption && <div className='add-column-option-container'>
                                <div className='option-heading'>Patient Monitor</div>
                                {HOME_PAGE.ADD_COLUMN_CONSTANT.MONITOR.map((paramObj) => {
                                    return (
                                        <div className='add-column-option' key={paramObj.name}>
                                            <input
                                                type="checkbox"
                                                checked={ifAddColumnOptionChecked(paramObj)}
                                                onChange={(event) => handleAddColumnItemClick(event, paramObj)} />
                                            <div className='option-label'>{paramObj.label}</div>
                                        </div>);
                                })}
                                <div className='option-heading'>Ventilator</div>
                                {HOME_PAGE.ADD_COLUMN_CONSTANT.VENTILATOR.map((paramObj) => {
                                    return (
                                        <div className='add-column-option' key={paramObj.name}>
                                            <input
                                                type="checkbox"
                                                checked={ifAddColumnOptionChecked(paramObj)}
                                                onChange={(event) => handleAddColumnItemClick(event, paramObj)} />
                                            <div className='option-label'>{paramObj.label}</div>
                                        </div>);
                                })}
                            </div>}
                        </div>}
                    </div> */}
                    {selectedWard && <BedContainer selectedWard={selectedWard} />}
                </div>
            </div>
            {modalConfig && modalConfig.isOpen && <PatientModal optionType={modalConfig.optionType} bedId={modalConfig.bedId} />}
        </>
    );
}

const mapStateToProps = state => {
    return {
        // bedDetails: state.bedDetailsReducer.bedDetails,
        bedData: state.bedDetailsReducer.bedData,
        wardDetails: state.wardDetailsReducer.wardDetails,
        config: state.configReducer.config,
        hospitalData: state.hospitalDataReducer.hospitalData,
        selectedWard: state.wardDetailsReducer.selectedWard,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        selectedWardAction: (payload) => dispatch(selectedWardAction(payload)),
        hospitalDataAction: (payload) => dispatch(hospitalDataAction(payload)),
        bedDetailAction: (payload) => dispatch(bedDetailAction(payload)),
        bedIdAction: (payload) => dispatch(bedIdAction(payload)),
        wardDetailsAction: (payload) => dispatch(wardDetailsAction(payload)),
        patientDataAction: (payload) => dispatch(patientDataAction(payload)),
        deviceVitalDataAction: (payload) => dispatch(deviceVitalDataAction(payload)),
        alarmDataAction: (payload) => dispatch(alarmDataAction(payload)),
        notificationDataAction: (payload) => dispatch(notificationDataAction(payload)),
        viewTypeAction: (payload) => dispatch(viewTypeAction(payload)),
        filterAction: (payload) => dispatch(filterAction(payload)),
        addColumnBedListAction: (payload) => dispatch(addColumnBedListAction(payload)),
        removeColumnBedListAction: (payload) => dispatch(removeColumnBedListAction(payload)),
        bedDataAction: (payload) => dispatch(bedDataAction(payload)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);